import React from "react";
import { theme, websiteColors } from "../../themes/Theme.js";
const CaseStudiesCard = ({
  caseStudies
}) => {
  const {
    title,
    description,
    image,
    readMoreLink
  } = caseStudies;
  return <div className="col-lg-4 cursor-pointer col-md-6 font-figtree col-sm-6 mb-4 d-flex" data-sentry-component="CaseStudiesCard" data-sentry-source-file="CaseStudiesCard.jsx">
            <div className="event-card d-flex flex-column gap-4" style={{
      width: "100%"
    }}>
               <div className="cs-image-container">

                 <img src={image} className="card-img-top cs-image" alt={title} />
               </div>
                <div className="d-flex flex-column">
                    <div className="d-flex flex-column justify-content-between">
                        <div className="d-flex justify-content-between">
                            <h5 style={{
              maxWidth: "305px"
            }} className="card-title">{title}</h5>
                         
                        </div>
                        <div>
                            <ul className="list-unstyled">
                                <li>
                                    <span className="list-item-txt">{description}</span>
                                </li>
                            </ul>
                            <p className="card-price">
                            <a href={readMoreLink} target="_blank" download={readMoreLink} rel="noopener noreferrer">Read More <img src="/img/lsicon_arrow-right-outline.svg" alt="" /></a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>
                {`
                    .event-card {
                        border: 1px solid #d9d9d9;
                        border-radius: 8px;
                        transition: transform 0.2s ease;
                        display: flex;
                        flex-direction: column;
                        height: 100%;
                        padding: 16px;
                    }

                    .event-card:hover {
                        //transform: translateY(-5px);
                    }

                    .event-card .card-img-top {
                        object-fit: contain;
                        border-radius: 8px;
                        border: 1px solid #d9d9d9;
                    }

                    .event-card .card-body {
                        padding: 16px;
                        flex-grow: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                    }
                    .cs-image-container{
                        max-width: 480px;
                        max-height: 270px;
                    }
                    .cs-image{
                        width: 100%;
                        min-height: 148px;
                        height: 100%;
                        object-fit: cover !important;
                    }
                    .event-card .card-title {
                        font-size: 20px;
                        font-weight: 600;
                        color: ${websiteColors[theme].primaryWebsiteTheme};
                        line-height: 24px;
                        height: 48px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .event-card .list-unstyled {
                        padding: 0;
                        margin: 10px 0;
                        font-size: 14px;
                        color: #666;
                    }

                    .event-card .list-unstyled li {
                        margin-bottom: 7px;
                    }

                    .event-card .card-price {
                        font-size: 14px;
                        //font-weight: 600;
                        line-height: 24px;
                        color: ${websiteColors[theme].primaryWebsiteTheme};
                        margin-top:10px;
                    }
                    button:focus, select:focus, textarea:focus {
                        box-shadow: 0px 0px 0px  !important;
                    }

                    .list-item-txt {
                        font-size: 14px;
                        font-weight: 500;
                        color: #525252;
                        line-height: 21px;
                    }
                     .share-options {
                         position: absolute;
                         right: 12px;
                         bottom: 65px;
                         width: 180px;
                         background: #fff;
                         border-radius: 10px;
                         box-shadow: 0px 4px 100px 0px rgba(0, 0, 0, 0.25);
                         z-index: 100;
                     }
                     .share-options span {
                         font-size: 12px;
                     }  
                    .share-box {
                        box-sizing: border-box;
                        width: auto;
                        height: 41px;
                        background: #FFF;
                        cursor: pointer;
                        border: 1px solid #572148;
                        border-radius: 50px;
                    }

                    @media (max-width: 768px) {
                        .event-card img {
                           // height: 120px;
                        }
                    }
                    @media (max-width: 1200px) {
                        .card-title {
                            max-width:218px !important;
                        }
                    }
                `}
            </style>
        </div>;
};
export default CaseStudiesCard;